module.exports = __webpack_public_path__ + "static/media/architect.8acb095c.jpg";